<template>
	<div class="wp-footer-container">
		<div class="wp-footer">
			<div class="class-over">
				<div class=" wp-header">
					<a :href="lang=='en'?'https://classover.com/en/':'https://classover.com/cn/'"><img class="logo" src="../assets/img/logo.png" alt="logo" /></a>
<!--					<div>-->
<!--						<img src="../assets/img/cn.png" alt="" @click="langChange('zh_CN') ">-->
<!--						<img src="../assets/img/us.png" alt="" @click="langChange('en') " >-->
<!--					</div>-->
				</div>


				<span class="describe">Classover is an afterschool live online enrichment program based in Manhattan, New York.</span>
				<div class="copy-right">
						<span>Classover.com © 2024</span>
					</div>
			</div>
			<div class="footer-list">
				<div class="list-item">
					<label for="">Company</label>
					<a href="https://classover.com/en/aboutus/">About Us</a>
					<a href="https://classover.com/en/contact-us/">Contact Us</a>
					<a href="https://classover.com/en/faqs/">FAQs</a>
					<a href="https://classover.com/en/category/blog/">Blog</a>
					<a href="https://classover.com/en/privacy-policy/">Privacy & Refund Policy</a>
				</div>
				<div class="list-item">
					<label for="">Explore</label>
					<a href="https://classover.com/en/our-courses-new/">Our Courses</a>
					<a href="https://classover.com/en/teachers-2/">Teachers</a>
					<a href="https://www.indeed.com/q-Classover-jobs.html">Careers</a>
					<a href="https://app.classover.com/pricing/">Pricing</a>
					<a href="https://classover.com/en/download/">Download</a>
				</div>
				<div class="list-download">
					<label for="">Download</label>
					<div>
						<span>for student</span>
						<div>
<!--							<a href="https://apps.apple.com/cn/app/classover-student/id1576159896?l=en"><img src="../assets/img/app-store.png" alt="app sotre" /></a>-->
							<a href="https://apps.apple.com/us/app/classover-student/id1576159896?l=en"><img src="../assets/img/app-store.png" alt="app sotre" /></a>
						<a href="https://app.classover.com/download/ClassoverStudent.apk"><img src="../assets/img/google-play.png" alt="google play" /></a>
						</div>

					</div>
					<div>
						<span>for parent</span>
						<div>
							<a href="https://apps.apple.com/us/app/classover-parent/id1573232431?l=en"><img src="../assets/img/app-store.png" alt="app sotre" /></a>
						<a href="https://app.classover.com/download/ClassoverParent.apk"><img src="../assets/img/google-play.png" alt="google play" /></a>
						</div>

					</div>
				</div>
			</div>
		</div>
		<!-- <div class="copy-right">
			<span>Classover.com © 2022</span>
		</div> -->
	</div>
</template>

<script>
     import i18n from '../locales/i18n';
	 import { setStore, keys, getStore, clearStore } from '../store';
	export default {
		data() {
			return {
				lang:'',
			};
		},
		mounted(){
			this.lang = i18n.locale;
		},
		methods:{
			langChange(command) {
				if (command === this.lang) return;

				setStore(keys.lang, command);
				this.$i18n.locale = command;
				this.lang = command;
				location.reload();
			},
		}
	};
</script>

<style scoped lang="less">
.wp-footer-container{
	box-shadow: 0px 0px 14px 4px rgba(0, 0, 0, 0.11);
}
.wp-footer {
		max-width: 1076px;
		padding-top: 36px;
		// width: 1000px;
		margin-left: auto;
		margin-right: auto;
		padding-bottom: 130px;
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
		.logo {
			width: 206.56px;
			height: 57.97px;
			display: block;
			// margin: auto;
		}

.footer-list {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			margin: auto;

			> div {
				display: flex;
				flex-direction: column;

				// & + div {
				// 	margin-left: 110px;
				// }
			}

			label {
				font-weight: 600;
				font-size: 16px;
				line-height: 242%;
				/* or 29px */

				/* Text */

				color: #000;
			}

			a {
				font-weight: 300;
				font-size: 14px;
				line-height: 242%;
         text-decoration: none;
				/* or 27px */

				/* Text */

				color: #3b495e;
			}

			img + img {
				margin-top: 10px;
			}
		}
.describe {
			font-size: 10px;
			line-height: 182%;
			width: 300px;
			color: #a8a8a8;
			display: block;
            margin-left:10px;
		}
		.wp-header{
			div{
				img{
					cursor:pointer;
				}
			}
		}

	@media screen and (min-width: @device) {
		.imgtotail{
			margin-top: 20px;
			margin-bottom: 30px;
			img{
				width: 120px;
			}
		}
		.wp-header{
			display: flex;
			flex-direction:row;
			// align-self:auto;
			div{
				height: 20px;
				margin: auto;
			}


		}
		.wp-footer-container{
			margin-top: 200px;
		}
		.footer-list {
			> div {
				& + div {
					margin-left: 110px;
				}
			}
		}

		.list-download {
			> div {
				flex-direction: column;
				div{
					display: flex;
					flex-direction: column;
				}
			}
		}

		// .wp-footer {
		// 	margin-bottom: 80px;
		// }

		.copy-right {
			// background: #f5f5f5;
			span {
				// width: 1280.02px;
				height: 35.32px;
				line-height: 35.32px;
				font-size: 7.99598px;
				margin: 0 auto;
				color: #9e9e9e;
				display: block;
			}
		}

	}

	@media screen and (max-width: @device) {
		.imgtotail{
			position: relative;
			img{
				width: 80px;
				position: absolute;
				top: 430px;
				left: calc(50% - 40px);
			}
		}
		.wp-header{
			div{
				display: none;
			}
		}
		.describe {
			width: 290px;
            font-size: 10px;
			height: 36px;
			font-weight: 400;
			font-family: 'Poppins';
			margin-bottom: 24px;
			margin-top: 18px;
		}
		.footer-list {
			// width: 100%;
			flex-wrap: wrap;
			> .list-item {
				width: 50%;
				label{
					font-size: 12px;
					color : #3B495E ;
					font-weight: 600;
				}
				a{
					font-size: 11px;
				}
			}
		}

		.list-item {
			// margin-left: 20%;
			box-sizing: border-box;
			padding-left: 10%;
			// padding-left: 10%;
		}

		.list-download {
			width: 100%;
			flex-direction: column !important;
			flex-wrap: wrap !important;
			margin: auto;
			margin-top:24px;
			label {
				width: 100%;
				padding-left: 10%;
				color : #3B495E ;
				font-weight : 600 ;
                font-size : 12px ;
			}
			span{
				font-weight : 300 ;
                font-size : 10px ;
				color : #3B495E ;
			}

			> div {
				// width: 50%;
				flex-direction: column;
				padding-left: 10%;
				box-sizing: border-box;
				div{
					width: 80%;
					display: flex;
					justify-content:space-between;
				}
			}
		}
		.class-over{
			position: relative;
		}
		.copy-right {
			// height: 90px;
			text-align: center;
			color: #9e9e9e;
			font-weight: 400;
			font-size: 12px;
			width: 150px;
			position: absolute;
			top: 530px;
			left: calc(50% - 75px);
		}

	}



		// > div {
		// 	width: 50%;
		// }



		.class-over {
			margin: 0 auto;
		}

		.list-download {
			> div {
				display: flex;
				// flex-direction: column;
			}

			img {
				width: 91px;
				height: 31px;
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/WpFooter.vue